export const PAIRING_REASONS = [
  "teammates",
  "title_rivals",
  "standings_proximity",
  "form_delta",
  "rivalry",
  "rookies",
] as const;

export type PairingReason = (typeof PAIRING_REASONS)[number];

// Narrative is stored as a single "Title — Body" text column. Keep the split
// convention centralised here (mirrors the public RaceDetail.tsx renderer,
// which is not touched by this refactor).
export function splitNarrative(text: string | null): { title: string; body: string } {
  if (!text) return { title: "", body: "" };
  const idx = text.indexOf(" — ");
  if (idx === -1) return { title: "", body: text };
  return { title: text.slice(0, idx), body: text.slice(idx + 3) };
}

export function joinNarrative(title: string, body: string): string {
  const t = title.trim();
  const b = body.trim();
  if (!t) return b;
  return `${t} — ${b}`;
}
